import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/**
 * WebinarHtmlDescriptionComponent is meant to be a generic
 *  component, that can render webinar description html in
 *  the same fashion everywhere.
 *
 * It is by design that the formatted styles are abstracted
 *  away in the `Html` styled component.
 *
 * Please think twice before changing the styles or the inter-
 *  face of WebinarHtmlDescriptionComponent.
 */

export const Html = styled.div`
  background-color: transparent;

  & em {
    font-style: italic;
    font-weight: inherit;
  }

  & strong {
    font-style: inherit;
    font-weight: bold;
  }

  & p {
    font-size: 12px;
    line-height: 20px;
    margin: 0;
    padding: 0;
    padding-bottom: 2px;
    padding-top: 2px;
  }

  & ul {
    list-style: disc;
    padding: 10px;
    padding-left: 30px;
  }

  & ul li {
    line-height: 20px;
    padding: 0px;
    padding-bottom: 2px;
    padding-top: 2px;
  }
`

export const WebinarHtmlDescriptionComponent = ({ html }) => (
  <Html dangerouslySetInnerHTML={{ __html: html }} />
)

WebinarHtmlDescriptionComponent.propTypes = {
  html: PropTypes.string.isRequired,
}
